import { Expose, Type } from 'class-transformer';
import { SnModel } from '@lib/common/models';
import { SkydioMarkerDetails } from './skydio-marker-details';

export enum SkydioMarkerType {
  INCIDENT = 'INCIDENT',
}

export class SkydioMarker extends SnModel {
  /** Detailed description of the marker that will appear in the marker details. */
  @Expose()
  public description: string;

  /** Timestamp when the marker was created in ISO format, eg: 2022-05-03T03:10:52.503+00:00 */
  @Expose({ name: 'event_time' })
  public eventTime: string;

  /** Latitude in degrees. Range: -90 to 90 */
  @Expose()
  public latitude: number;

  /** Longitude in degrees. Range: -180 to 180 */
  @Expose()
  public longitude: number;

  /** A short title for the marker that will appear on the list view for the marker. */
  @Expose()
  public title?: string;

  /** The type of the marker. This will affect how the marker is displayed on the map view. */
  @Expose()
  public type: SkydioMarkerType;

  /** UUID of the marker. */
  @Expose()
  public uuid: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
